import React, { PureComponent } from 'react';
import { Popover as AntPopover, message as AntMessage, Button as AntButton } from 'antd';
import { services } from '@comall-backend-builder/core';
import QRCode from 'qrcode.react';
import { ComponentSelector } from '../../design_page/components/tools';

const language = services.language;
/**
 * 可视化页面预览
 */
export class PagePreviewButton extends PureComponent<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            goodContent: '',
        };
    }

    // copyLink = (url: any) => {
    //     return function() {
    //         let input = document.createElement('input');
    //         input.value = url;
    //         document.body.appendChild(input);
    //         input.select();
    //         if (document.execCommand('Copy')) {
    //             AntMessage.success('复制成功');
    //         } else {
    //             AntMessage.warning('复制失败');
    //         }
    //         document.body.removeChild(input);
    //     };
    // };
    renderContent = async () => {
        const { type, id } = this.props.row;
        console.log(type, id);
        let params = {};
        if (type == 'home') {
            params = {
                page: 'pages/preindex/index',
                scene: `t=H`,
                width: 430,
            };
        } else if (type == 'topic') {
            params = {
                page: 'pages/preindex/index',
                scene: `t=T&p=${id}`,
                width: 430,
            };
        } else if (type == 'point') {
            params = {
                page: 'pages/preindex/index',
                scene: `t=Point`,
                width: 430,
            };
        }
        const res: any = await services.api.post(params, {
            apiPath: '/orderReplaceSkn/get_mini_program',
        });
        this.setState({
            goodContent: `data:image/png;base64,${res.miniProgramCode}`,
        });
        // return (
        //     <div className="preview-content">
        //         <QRCode className="qr-code" value={url} />
        //         <p className="info">手机扫码预览</p>
        //         <p className="info">
        //             或点击
        //             <AntButton
        //                 type="link"
        //                 style={{ padding: 0 }}
        //                 className="span-link"
        //                 onClick={this.copyLink(url)}
        //             >
        //                 复制链接
        //             </AntButton>
        //             在手机打开
        //         </p>
        //     </div>
        // );
    };
    render() {
        const { type, id } = this.props.row;
        const { goodContent } = this.state;
        const content = <img src={goodContent} alt="" />;
        return (
            <AntPopover content={content} trigger="click" title="二维码">
                <a className="table-action-column-item" onClick={this.renderContent}>
                    {/* {type == 'topic' || type == 'home' ? '预览' : ''} */}
                    预览
                </a>
            </AntPopover>
        );
    }
}
